import React from 'react'
import { push as Menu } from 'react-burger-menu'
import classnames from 'classnames'
import { Link } from 'gatsby'
import ContactInfo from './ContactInfo'
import menuStyles from './menu.module.sass'

export default props => {
  const { allPages, burgerColor } = props

  const styles = {
    bmBurgerBars: {
      background: burgerColor,
    },
    bmItemList: {
      padding: 0,
      display: 'flex',
      flexDirection: 'column',
    },
  }
  return (
    <Menu
      className={classnames(menuStyles.menu, 'main-menu')}
      styles={styles}
      tabIndex="0"
    >
      {allPages &&
        allPages
          //.filter(edge => edge.node.title == 'Yoho National Park' ? .length < 12)
          .filter(edge => edge.node.slug !== 'covid-19')
          .map(edge => (
            <Link
              className="navbar-item"
              to={edge.node.slug === 'home' ? '/' : `/${edge.node.slug}`}
              key={edge.node.slug}
            >
              {edge.node.title === 'Yoho National Park'
                ? 'The Park'
                : edge.node.title}
            </Link>
          ))}
      <ContactInfo />
    </Menu>
  )
}
